"use client";

import { FeatherMonitor } from "@subframe/core";

/**
 * Full-height placeholder shown in place of a screen that isn't optimised for
 * small viewports yet (e.g. the manager dashboard). Render this via an early
 * return when `useIsMobile()` is true so the surrounding sidebar/nav stays put
 * and the user can still navigate to mobile-friendly screens.
 */
export function DesktopOnlyNotice() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-navy-50">
        <FeatherMonitor className="text-heading-1 font-heading-1 text-primary-navy-800" />
      </div>

      <h2 className="text-heading-2 font-heading-2 text-neutral-900">
        Best viewed on desktop
      </h2>
      <p className="max-w-sm text-body font-body text-subtext-color">
        The dashboard isn&apos;t optimised for mobile yet. Please open it in a
        desktop browser for the full experience.
      </p>
    </div>
  );
}
